import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpCircle } from 'lucide-react';

// --- BACK TO TOP BUTTON ---
const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.button
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    className="fixed bottom-8 right-8 bg-cyan-500/80 dark:bg-cyan-400/80 text-black p-3 rounded-full shadow-lg backdrop-blur-sm hover:bg-cyan-500 dark:hover:bg-cyan-400 z-50"
                    aria-label="Go to top"
                >
                    <ArrowUpCircle size={24} />
                </motion.button>
            )}
        </AnimatePresence>
    );
};

export default BackToTopButton;
